<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Type')"
                  v-model.trim="item.type"
                  name="className"
                  :disabled="true"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('Type')"
                  :data-vv-as="$t('Type')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Img Background')"
                  v-model.trim="item.imgBackground"
                  name="className"
                  maxLength="250"
                  :error-messages="errors.first('imgBackground')"
                  :data-vv-as="$t('imgBackground')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Img Close')"
                  v-model.trim="item.imgClose"
                  name="className"
                  maxLength="250"
                  :error-messages="errors.first('imgClose')"
                  :data-vv-as="$t('imgClose')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Voice Path')"
                  v-model.trim="item.voicePath"
                  name="className"
                  maxLength="250"
                  :error-messages="errors.first('voicePath')"
                  :data-vv-as="$t('voicePath')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    units: {
      type: Array,
      default: [],
    },

    programs: {
      type: Array,
      default: [],
    },
  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        type:"",
        imgBackground: "",
        imgClose: "",
        voicePath: "",
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        console.log(value);
        if (value !== null) {
          this.item = {
            id: value.id,
            type: value.type,
            imgBackground: value.imgBackground,
            imgClose: value.imgClose,
            voicePath: value.voicePath,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        content: "",
      };
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    clearDropDate() {
      this.item.startDate = '';
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }

        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/notify/savePopup", this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
  },
};
</script>
